.layout {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  min-width: 0;
  padding-top: var(--pgm-sys-spacing-6);
}

.header {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
  justify-content: space-between;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.createButton {
  flex-shrink: 0;
}

.filters {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
}

.search {
  flex: 1 1 320px;
  max-width: 480px;
}

.filters .statusFilter,
.filters .roleFilter {
  --md-outlined-field-top-space: 16px;
  --md-outlined-field-bottom-space: 16px;
  --md-outlined-field-with-label-top-space: 16px;
  --md-outlined-field-with-label-bottom-space: 16px;
  flex: 0 0 200px;
}

.filters .roleFilter {
  flex-basis: 240px;
}

.count {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: calc(-1 * var(--pgm-sys-spacing-3)) 0 0;
}

.name {
  align-items: center;
  display: inline-flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-2);
}

.youTag {
  background-color: var(--pgm-sys-color-primary-container);
  border-radius: 8px;
  color: var(--pgm-sys-color-on-primary-container);
  padding: 0 var(--pgm-sys-spacing-2);
}

.email {
  color: var(--pgm-sys-color-on-surface-variant);
  overflow-wrap: anywhere;
}

.muted {
  color: var(--pgm-sys-color-on-surface-variant);
}

.actions {
  display: inline-flex;
  gap: var(--pgm-sys-spacing-1);
  justify-content: flex-end;
}

.roleTags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-1);
}

.tag {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  flex-shrink: 0;
  gap: 6px;
  padding: 2px 8px;
  white-space: nowrap;
}

.tagDot {
  border-radius: 50%;
  height: 8px;
  width: 8px;
}

.tagActive {
  background-color: var(--pgm-sys-color-success-container);
  color: var(--pgm-sys-color-on-success-container);
  padding-left: 6px;
}

.tagActive .tagDot {
  background-color: var(--pgm-sys-color-success);
}

.tagInactive {
  background-color: var(--pgm-sys-color-surface-container-highest);
  color: var(--pgm-sys-color-on-surface-variant);
  padding-left: 6px;
}

.tagInactive .tagDot {
  background-color: var(--pgm-sys-color-outline);
}

.tagRole {
  background-color: var(--pgm-sys-color-secondary-container);
  color: var(--pgm-sys-color-on-secondary-container);
}

.compactRow {
  align-items: flex-start;
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  justify-content: space-between;
}

.compactMain {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.compactName {
  color: var(--pgm-sys-color-on-surface);
}

.compactTags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-1);
  margin-top: var(--pgm-sys-spacing-1);
}

.empty,
.error {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
  text-align: center;
}

.error {
  background-color: var(--pgm-sys-color-surface-container-lowest);
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 12px;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6);
}

.emptyIcon {
  color: var(--pgm-sys-color-on-surface-variant);
  font-size: 48px;
  line-height: 1;
}

.emptyText {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding-top: var(--pgm-sys-spacing-2);
}

.field {
  min-height: 80px;
}

.roles {
  border: 0;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: 0 0 var(--pgm-sys-spacing-4);
  min-width: 0;
  padding: 0;
}

.legend {
  color: var(--pgm-sys-color-on-surface);
  margin-bottom: var(--pgm-sys-spacing-1);
  padding: 0;
}

.roleOption {
  display: flex;
  flex-direction: column;
}

.roleDescription {
  color: var(--pgm-sys-color-on-surface-variant);
  margin-top: calc(-1 * var(--pgm-sys-spacing-2));
  padding-left: 56px;
}

.fieldError {
  color: var(--pgm-sys-color-error);
}

.passwordFields {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
}

.passwordHint {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.passwordReset {
  display: flex;
  margin-left: calc(-1 * var(--pgm-sys-spacing-3));
}

.formError {
  color: var(--pgm-sys-color-error);
  margin: 0;
}

@media (max-width: 599.98px) {
  .createButton {
    width: 100%;
  }

  .search,
  .filters .statusFilter,
  .filters .roleFilter {
    flex: 1 1 100%;
    max-width: none;
  }
}
